export function getImageSrc(imageName: string): string {
  if (window.location.hostname === 'localhost') {
    return `/assets/${imageName}`;
  }
  return `https://vstatic-prod.apigateway.co/wsp-portal-client.9223372035065798524.demo/assets/${imageName}`;
}
